import * as yup from 'yup'

export const blankBooking = () => {
  return {
    createdBy: '', // this will be set by the user
    checkIn: '',
    checkOut: '',
    propertyId: '',
    dateRange: null, // delete this
    pricePerNight: '',
    earnings: '', // work this in
    cleaning: '', // fill this in with the property cleaning
    source: '',
    sourceConfirmation: '',
    contactInfo: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
    dateBooked: '',
    dateUpdated: '',
    dateInquired: '',
    bookingStatus: 'new',
    requiresConfirmation: false,
    confirmationCode: '',
    requiresBookingGuestInfo: false,
    bookingGuestInfoId: '',
    guestInfo: {
      guestTotal: '',
      adults: '',
      children: '',
      infants: '',
      pets: '',
    },
    cancellation: {
      amount: '',
      amountType: 'percentage',
    },
    linkedServices: [],
    fees: [],
    notes: '',
    scrapeId: '',
    turnoverId: '',
  }
}

export const bookingSchema = (options: any) => yup.object().shape({
  checkIn: yup.date().required("Check-in date is required"),
  checkOut: yup.date().required("Check-out date is required"),
  propertyId: yup.string().required("Property ID is required"),
  pricePerNight: yup.number().nullable(),
  earnings: yup.number().nullable(),
  cleaning: yup.number().nullable(),
  source: yup.string().nullable(),
  sourceConfirmation: yup.string(),
  contactInfo: yup.object().shape({
    firstName: yup.string().required("First name is required"),
    // firstName: options.isOwner ? yup.string().required("First name is required") : yup.string().nullable(),
    lastName: yup.string().required("Last name is required"),
    // lastName: options.isOwner ? yup.string().required("Last name is required") : yup.string().nullable(),
    email: yup.string().email().nullable(),
    phone: yup.string().nullable(),
  }),
  dateBooked: yup.date().nullable(),
  dateInquired: yup.date().nullable(),
  bookingStatus: yup.string().required(),
  requiresConfirmation: yup.boolean(),
  confirmationCode: yup.string().nullable(),
  requiresBookingGuestInfo: yup.boolean(),
  bookingGuestInfoId: yup.string().nullable(),
  guestInfo: yup.object().shape({
    guestTotal: yup.number().nullable(),
    adults: yup.number().nullable(),
    children: yup.number().nullable(),
    infants: yup.number().nullable(),
    pets: yup.number().nullable(),
  }),
  cancellation: yup.object().shape({
    amount: yup.number().nullable(),
    amountType: yup.string().nullable(),
  }),
  fees: yup.array().of(yup.object().shape({
    feeType: yup.string().required("Fee type is required"),
    feeSource: yup.string().required("Fee source is required"),
    feeAmount: yup.number().typeError("Fee amount must be a number").required("Fee amount is required"),
  })),
  notes: yup.string().nullable(),
  scrapeId: yup.string().nullable(),
  turnoverId: yup.string().nullable(),
})
